import { useQuery } from "@tanstack/react-query";
import { getAccount, type AccountResponse } from "../api/account.api";
import { ApiError } from "@/lib/api/client";

export const accountKeys = {
  all: ["account"] as const,
  me: () => [...accountKeys.all, "me"] as const,
};

export function useAccount() {
  return useQuery<AccountResponse, ApiError>({
    queryKey: accountKeys.me(),
    queryFn: getAccount,
  });
}
